import request from './common/request'
import qs from 'qs'

import { LOGIN_URL, MERCHANT_AUTH_URL, GET_MERCHANT_BASE_INFO_URL, GET_MERCHANT_BASE_INFOS_URL, GET_MERCHANT_BASE_INFOS_BY_MOBILE_URL, SYSTEM_MERCHANT_OPEN_ACCOUNT_URL, SLIDER_CAPTCHA_URL, SLIDER_CAPTCHA_CHECK_URL, RESET_PASSWORD_URL, GET_MERCHANTS_URL, SELECT_MERCHANT_URL } from './urls'

// 获取验证码
async function getCaptchaImage (url) {
  return request(
    {
      url: url,
      method: 'GET',
      responseType: 'arraybuffer'
    }
  )
}
/**
 * 获取滑块验证码
 * @returns {Promise} 返回验证码数据，包含背景图片、模板图片和验证码ID
 */
async function getSliderCaptcha () {
  return request(
    {
      url: SLIDER_CAPTCHA_URL,
      method: 'POST',
      data:{}
    }
  )
}
/**
 * 校验滑块验证码
 * @param {Object} data - 校验参数
 * @param {String} data.id - 验证码ID（来自「获取滑块验证码」返回的 data.id）
 * @param {Object} data.track - 滑动轨迹对象
 * @returns {Promise} 返回校验结果
 */
async function checkSliderCaptcha(data) {
  return request({
    url: SLIDER_CAPTCHA_CHECK_URL,
    method: 'POST',
    data: data
  })
}
// 登录接口
async function login (data) {
  return request(
    {
      url: LOGIN_URL,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 手机登录
async function mobileLogin (data) {
  return request(
    {
      url: `${MERCHANT_AUTH_URL}/phonelogin`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

/**
 * 手机号验证码获取商户列表
 * @param params
 * @returns
 */
export function getAccountByPhoneCodeApi(params) {
  return request({
    url: `${MERCHANT_AUTH_URL}/pclogin/getAccounts`,
    method: 'POST',
    data: qs.stringify(params)
  })
}

async function getMobileRegisterSMS (params) {
  return request(
    {
      url: `${MERCHANT_AUTH_URL}/regcode`,
      method: 'GET',
      params: params
    }
  )
}

// 获取手机登录验证码
async function getMobileLoginSMS (params) {
  return request(
    {
      url: `${MERCHANT_AUTH_URL}/logincode`,
      method: 'GET',
      params: params
    }
  )
}

async function getMerchantBaseInfos () {
  return request(
    {
      url: GET_MERCHANT_BASE_INFOS_URL,
      method: 'GET'
    }
  )
}

async function getMerchantBaseInfo (params) {
  return request(
    {
      url: GET_MERCHANT_BASE_INFO_URL,
      method: 'GET',
      params
    }
  )
}

async function queryBaseInfos (params) {
  return request(
    {
      url: GET_MERCHANT_BASE_INFOS_URL,
      method: 'GET',
      params: params
    }
  )
}

async function queryBaseInfosByMobile (mobile) {
  return request(
    {
      url: GET_MERCHANT_BASE_INFOS_BY_MOBILE_URL,
      method: 'GET',
      params: {
        mobile
      }
    }
  )
}

async function registerMerchant (data) {
  return request(
    {
      url: `${MERCHANT_AUTH_URL}/register`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function getWxLoginParams () {
  return request(
    {
      url: `${MERCHANT_AUTH_URL}/wxlogin/params`,
      method: 'GET'
    }
  )
}

async function wxLogin (data) {
  return request(
    {
      url: `${MERCHANT_AUTH_URL}/wxlogin/login`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function getWxLoginAccountsByCode (code) {
  return request(
    {
      url: `${MERCHANT_AUTH_URL}/wxlogin/getLoginAccountByCode`,
      method: 'GET',
      params: { code }
    }
  )
}

async function accountLoginByUuid (data) {
  return request(
    {
      url: `${MERCHANT_AUTH_URL}/accountlogin/uuid`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function getWxLoginUuid () {
  return request(
    {
      url: `${SYSTEM_MERCHANT_OPEN_ACCOUNT_URL}/h5wx/uuid`,
      method: 'GET'
    }
  )
}

async function getOpenAccounts () {
  return request(
    {
      url: `${SYSTEM_MERCHANT_OPEN_ACCOUNT_URL}`,
      method: 'GET'
    }
  )
}

/**
 * 重置密码
 * @param {Object} data - 重置密码参数
 * @param {String} data.token - 重置密码的临时token（来自登录接口返回的data.token）
 * @param {String} data.password - 新密码
 * @returns {Promise} 返回重置结果
 */
async function resetPassword(data) {
  // 根据API文档，重置密码接口：
  // 1. Header: Authorization: Bearer {RESET_PWD_TEMP token}
  // 2. Body: { newPassword: "新密码" } (JSON格式)
  return request({
    url: RESET_PASSWORD_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    // 将临时token传递给请求拦截器
    resetPasswordToken: data.token,
    // Body只包含新密码，token通过Authorization header传递
    data: {
      newPassword: data.password
    }
  })
}

/**
 * 获取商户列表（LOGIN_TEMP场景）
 * 根据API文档：GET /merchant/auth/main/merchants
 * 仅当主账号登录返回 tokenType === 'LOGIN_TEMP' 时调用
 * 用于展示商户列表供用户选择
 * 
 * @param {String} tempToken - 临时登录token（LOGIN_TEMP），来自登录接口返回的data.token或data.t
 * @returns {Promise<Array>} 返回商户列表，每个商户包含：
 *   - name: 商户名称
 *   - shortName: 商户简称
 *   - choiceId: 商户选择ID（用于后续登录）
 */
async function getMerchants(tempToken) {
  if (!tempToken) {
    return Promise.reject(new Error('获取商户列表需要临时token（LOGIN_TEMP）'))
  }
  
  return request({
    url: GET_MERCHANTS_URL,
    method: 'GET',
    // 将临时token传递给请求拦截器
    merchantsToken: tempToken
  })
}

/**
 * 选择商户并获取正式token（LOGIN_TEMP场景）
 * 根据API文档：POST /merchant/auth/main/select-merchant
 * 用户从商户列表中选一个商户后，用该商户的choiceId调用本接口，换取正式JWT
 * 调用成功后当前登录用临时凭证会失效
 * 
 * @param {Object} params - 请求参数
 * @param {String} params.choiceId - 商户选择ID（来自商户列表中的choiceId）
 * @param {String} params.tempToken - 临时登录token（LOGIN_TEMP），来自登录接口返回的data.token或data.t
 * @returns {Promise<Object>} 返回正式JWT token及相关信息，包含：
 *   - token/t: 正式JWT token
 *   - mode: 模式
 *   - id: 管理员ID
 *   - merchantInfo: 商户信息
 *   - 其他用户信息
 */
async function selectMerchant(params) {
  const { choiceId, tempToken } = params || {}
  
  if (!choiceId) {
    return Promise.reject(new Error('选择商户需要提供choiceId'))
  }
  
  if (!tempToken) {
    return Promise.reject(new Error('选择商户需要临时token（LOGIN_TEMP）'))
  }
  
  return request({
    url: SELECT_MERCHANT_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    // 将临时token传递给请求拦截器
    selectMerchantToken: tempToken,
    // Body包含choiceId
    data: {
      choiceId: choiceId
    }
  })
}

export default {
  getCaptchaImage,
  getSliderCaptcha,
  checkSliderCaptcha,
  login,
  mobileLogin,
  getAccountByPhoneCodeApi,
  getMerchantBaseInfos,
  getMerchantBaseInfo,
  queryBaseInfos,
  getMobileRegisterSMS,
  getMobileLoginSMS,
  registerMerchant,
  queryBaseInfosByMobile,
  getWxLoginParams,
  wxLogin,
  getWxLoginAccountsByCode,
  getWxLoginUuid,
  accountLoginByUuid,
  getOpenAccounts,
  resetPassword,
  getMerchants,
  selectMerchant
}



// WEBPACK FOOTER //
// ./src/api/merchant-auth.js